/* eslint-disable */
import * as THREE from 'three'
import { d392, d393 } from './h.js'
import r1 from '@/oceanSchool/r1.js'
import h from '@/oceanSchool/b.js'

var o = function (e) {
  function c(e, t, n) {
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, c);
    var i = d392
      , r = d393
      , o = new THREE.PlaneGeometry
      , a = h.default.get("/images/" + t)
      , s = h.default.get("/images/" + e)
      , l = new THREE.ShaderMaterial({
        uniforms: {
          u_originalImage: {
            type: "t",
            value: s
          },
          u_mapImage: {
            type: "t",
            value: a
          },
          u_mouse: {
            type: "v2",
            value: {
              x: 0,
              y: 0
            }
          }
        },
        vertexShader: i,
        fragmentShader: r,
        transparent: !0,
        depthTest: !0
      })
      , u = function (e, t) {
        if (!e)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t
      }(this, (c.__proto__ || Object.getPrototypeOf(c)).call(this, o, l));
    return u.intensity = n.intensity || -.022,
      u.smooth = n.smooth || .05,
      u.image = {
        width: n.w,
        height: n.h
      },
      u.mouseRatio = {
        x: 0,
        y: 0
      },
      u.nMouse = {
        x: 0,
        y: 0
      },
      u.resize(),
      u
  }
  return function (e, t) {
    if ("function" != typeof t && null !== t)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }),
      t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
  }(c, THREE.Mesh),
    r1(c, [{
      key: "render",
      value: function (e) {
        this.mouseRatio.x = window.mouse.x / this.image.width * 2 - 1,
          this.mouseRatio.y = window.mouse.y / this.image.height * 2 - 1,
          e && (this.mouseRatio.y += Math.sin(e.y),
            this.mouseRatio.x += Math.sin(e.x)),
          this.nMouse.x += (this.mouseRatio.x * this.intensity - this.nMouse.x) * this.smooth,
          this.nMouse.y += (this.mouseRatio.y * this.intensity - this.nMouse.y) * this.smooth,
          this.material.uniforms.u_mouse.value = this.nMouse
      }
    }, {
      key: "resize",
      value: function () {
        var e = window.w + 100
          , t = window.w / this.image.width
          , n = Math.floor(this.image.height * t);
        this.scale.x = e,
          this.scale.y = n
      }
    }, {
      key: "dispose",
      value: function () {
        this.geometry.dispose(),
          this.material.dispose(),
          this.intensity = this.smooth = this.image = this.mouseRatio = this.nMouse = null
      }
    }]),
    c
}();
var t = { default: o }

export default t
